import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeRightAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe_right_alt"}/>
}
